<template>
  <div v-loading="loading">
    <el-alert
      v-if="customers && customers.data && customers.data.length === 0"
      type="info"
      show-icon
      title="Az összes szállítólevél ki lett számlázva."
    />
    <el-table
      v-if="customers && customers.data && customers.data.length"
      :data="customers.data"
      @sort-change="handleSortChange"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <sale-list
            :billable-sales="[...scope.row.customer_sales.map(sale => ({...sale, type: 'customerSale'})), ...scope.row.representative_sales.map(sale => ({...sale, type: 'representativeSale'}))]"
            :customer-id="scope.row.id"
            @createInvoice="onCreateInvoice"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="company.name"
        label="Vevő"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.company.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="customer_sales_count"
        label="Szállítólevelek"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.customer_sales_count + scope.row.representative_sales_count }} db
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="partners && partners.data && partners.data.length"
      class="el-card-footer"
    >
      <el-pagination
        background
        :current-page.sync="query.currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="customers.per_page"
        layout="total, prev, pager, next"
        :total="customers.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import SaleList from './BillableSaleList';

  export default {
    components: { SaleList },
    props: ['partnersWithBillable'],

    data() {
      return {
        partners: [],
        query: {
          currentPage: 1,
          sorting: {
            prop: 'company.name',
            order: 'ascending',
          }
        }
      };
    },

    computed: {
      loading() {
        return this.$store.getters['partner/customersWithBillableLoading'];
      },
      customers() {
        return this.$store.getters['partner/customersWithBillable'];
      }
    },

    async mounted() {
      await this.$store.dispatch('partner/fetchCustomersWithBillableWithPagination', this.query);
    },

    methods: {
      async handleCurrentChange(val) {
        this.query.currentPage = val;
        await this.$store.dispatch('partner/fetchCustomersWithBillableWithPagination', this.query);
      },

      async handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.query.sorting.prop = prop;
          this.query.sorting.order = order;
          await this.$store.dispatch('partner/fetchCustomersWithBillableWithPagination', this.query);
        }
      },

      onCreateInvoice(data) {
        this.$emit('createInvoice', data);
      }
    }
  };
</script>
